import React from 'react'
import {Navigate, useParams} from 'react-router-dom'
import AddCropPageWrapper from './AddCrop'
import {getCropMasterPath} from './cropMasterRoutes'

const CropDetailsPage = () => {
 const {cropId} = useParams<{cropId: string}>()

 if (!cropId || !/^\d+$/.test(cropId)) {
  return <Navigate to={getCropMasterPath()} replace />
 }

 return <AddCropPageWrapper cropId={Number(cropId)} />
}

export default CropDetailsPage
